import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorOrange = createSvgIcon(
  <circle cx="10" cy="10" fill="#FC7E09" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorOrange',
);
